// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".execute-unsubscribe[data-v-ed8339c2]{text-align:center}.execute-unsubscribe .unsubscribe-button[data-v-ed8339c2]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
